import React from 'react';

import {
  ReferenceArrayField,
  useRecordContext,
} from 'react-admin';

import { get } from 'lodash';

import ArrayDiffFieldLayout from './ArrayDiffFieldLayout';

const ReferenceArrayDiffField = ({
  source,
  objectSource,
  label,
  reference,
  children,
  size,
  width,
}: {
  source: string;
  objectSource?: string;
  label: string;
  reference: string;
  children: React.ReactNode;
  size?: {
    xs?: number;
    md?: number;
    xl?: number;
  };
  width?: string;
}) => {
  const record = useRecordContext();

  const oldValue = objectSource ? get(record, `${source}.oldValue`, []).map((item: any) => get(item, objectSource, item)) : get(record, `${source}.oldValue`, []);
  const newValue = objectSource ? get(record, `${source}.newValue`, []).map((item: any) => get(item, objectSource, item)) : get(record, `${source}.newValue`, []);

  const isItemRemoved = oldValue.length > 0;
  const isItemAdded = newValue.length > 0;

  return (
    <ArrayDiffFieldLayout
      label={label}
      size={size}
      width={width}
      removedElement={isItemRemoved && (
        <ReferenceArrayField
          record={{ id: 'old', value: oldValue }}
          source="value"
          reference={reference}
          page={1}
          perPage={200}
        >
          {children}
        </ReferenceArrayField>
      )}
      addedElement={isItemAdded && (
        <ReferenceArrayField
          record={{ id: 'new', value: newValue }}
          source="value"
          reference={reference}
          page={1}
          perPage={200}
        >
          {children}
        </ReferenceArrayField>
      )}
    />
  );
};

export default ReferenceArrayDiffField;
